import { Pipe, PipeTransform } from '@angular/core';

import { CustomTranslationsService } from '../translations';
import { TranslateService } from '@ngx-translate/core';
import { NO_VALUE } from '@pipes';

@Pipe({
  name: 'translateBypassConfiguration',
})
export class TranslateBypassConfigurationPipe implements PipeTransform {
  constructor(
    private customTranslationsService: CustomTranslationsService,
    private translateService: TranslateService
  ) {}

  transform(value: string): string {
    if (!value) {
      return NO_VALUE;
    }

    return (
      this.translateService.instant(
        this.customTranslationsService.VENTILATION_MODES_BYPASS_CONFIGURATION[value]
      ) ?? value
    );
  }
}
